import { BASE_URL } from "../URL/constants";
import { sendRequest } from '../ApiRequest';

export const addToWishlist = async (itemId, token) => {
  try {
    const response = await sendRequest('POST', `${BASE_URL}/v1/public_site/wishlists`, {item_id: itemId}, { Authorization: token });
    console.log("Response:", response);
  } catch (error) {
    console.error("Error adding to wishlist:", error);
    throw error;
  }
};

export const removeFromWishlist = async (itemId, token) => {
  try {
    const response = await sendRequest('DELETE', `${BASE_URL}/v1/public_site/wishlists/${itemId}`, null, { Authorization: token });
    console.log("Response:", response);
  } catch (error) {
    console.error("Error removing from wishlist:", error);
    throw error;
  }
};

export const checkWishlistStatus = async (itemId, token) => {
  try {
    const result = await sendRequest('GET', `${BASE_URL}/v1/public_site/wishlists`, null, { Authorization: token });
    const wishlistItems = result.data || [];
    return wishlistItems.some(item => item.item_id === Number(itemId));
  } catch (error) {
    console.error("Error checking wishlist status:", error);
    return false;
  }
};
